export const DDRAGON_VERSION = "16.1.1";
export const DDRAGON_BASE = `/assets/${DDRAGON_VERSION}`;
